// Welle 4.1 — Betreiber-Modus: Plattform-Gesundheit auf einen Blick.
// Pure business language, traffic lights, one-line explanations —
// no technical jargon (queues, workers, materialisers live in the
// developer mode only).
import React from "react";
import { useTranslation } from "react-i18next";
import { HeartPulse } from "lucide-react";
import { SectionCard, trafficLevel } from "./AdminV2Kit";

export default function PlatformHealthCard({ rows }) {
  const { t } = useTranslation("admin");
  const worst = rows.reduce((acc, r) => Math.min(acc, r.pct ?? 100), 100);
  return (
    <SectionCard
      title={t("health.title")}
      icon={HeartPulse}
      status={worst >= 85 ? "healthy" : worst >= 70 ? "attention" : "critical"}
      testid="adminv2-health-card"
    >
      <ul className="divide-y divide-zinc-800/60">
        {rows.map((r) => {
          const lvl = trafficLevel(r.pct);
          return (
            <li
              key={r.id}
              data-testid={`adminv2-health-${r.id}`}
              className="flex items-start gap-3 py-3 first:pt-0 last:pb-0"
            >
              <span className="mt-0.5 text-lg leading-none" aria-hidden="true">
                {lvl.emoji}
              </span>
              <div className="min-w-0 flex-1">
                <div className="flex flex-wrap items-baseline justify-between gap-x-3">
                  <span className="text-sm font-medium text-zinc-100">
                    {r.label}
                  </span>
                  <span className="text-sm text-zinc-300 tabular-nums">
                    {r.value}
                  </span>
                </div>
                <p className="mt-0.5 text-xs leading-snug text-zinc-500">
                  {r.desc}
                </p>
              </div>
            </li>
          );
        })}
      </ul>
    </SectionCard>
  );
}
